import { render, staticRenderFns } from "./PersonalInfoPage2.vue?vue&type=template&id=e82f2140&scoped=true&"
import script from "./PersonalInfoPage2.vue?vue&type=script&lang=ts&"
export * from "./PersonalInfoPage2.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalInfoPage2.vue?vue&type=style&index=0&id=e82f2140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82f2140",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VInput,VRadio,VRadioGroup,VRow,VTextField})
